import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';
import { CHART_COLORS } from 'styles/colors';

export const LoaderWrapper = styled.div`
	flex: 1;
	display: flex;
	flex-direction: column;
	justify-content: center;
	padding-bottom: 32px;
`;

export const NoData = styled.div`
	color: ${colors.grey7};
	font-size: 16px;
	letter-spacing: 0.3px;
	padding: 10px 0 32px 4px;
	border-top: 1px solid ${colors.grey3};
`;

export const TableWrapper = styled.div`
	padding-bottom: 32px;
	position: relative;
	width: 100%;
	height: ${({ height }) => (height ? `${height}px` : 'auto')};

	.ag-theme-balham {
		width: 100%;
		height: 100%;
		font-family: 'Roboto';

		.ag-root,
		.ag-side-bar,
		.ag-root-wrapper,
		.ag-status-bar {
			border: none;
		}

		.ag-root-wrapper {
			border-bottom: none;
		}

		.ag-header-row {
			border-bottom: 0px;
		}
		.ag-header {
			background-color: transparent;
			border: none;
			font-family: 'Roboto';

			.company-header {
				.ag-header-cell-text {
					position: relative;
					padding-left: 20px;

					&:before {
						content: '\\2B24';
						font-size: 10px;
						position: absolute;
						left: 0;
						top: -1px;
					}
				}

				&.color-1 .ag-header-cell-text:before {
					color: ${CHART_COLORS[0]};
				}
				&.color-2 .ag-header-cell-text:before {
					color: ${CHART_COLORS[1]};
				}
				&.color-3 .ag-header-cell-text:before {
					color: ${CHART_COLORS[2]};
				}
				&.color-4 .ag-header-cell-text:before {
					color: ${CHART_COLORS[3]};
				}
			}

			.ag-cell-label-container {
				overflow: hidden;
			}
		}

		.ag-body-viewport.ag-layout-auto-height .ag-center-cols-clipper {
			min-height: 24px;
		}

		.ag-header-cell {
			font-weight: normal;
			padding-bottom: 5px;
			font-size: 13px;
			line-height: 19px;
			letter-spacing: 0.3px;
			color: ${colors.grey5};

			&::after {
				display: none;
			}
		}

		.ag-row {
			background-color: transparent;
			border-color: ${colors.grey3};
			overflow: visible;

			&.ag-row-last {
				border-bottom: none;
			}

			.ag-cell {
				font-size: 13px;
				font-weight: normal;
				line-height: 24px;
				letter-spacing: 0.3px;
				color: ${colors.grey8};
			}

			svg {
				visibility: hidden;
			}

			&.ag-row-hover {
				svg {
					visibility: visible;
					&:hover {
						fill: ${colors.grey8};
					}
				}
			}
		}

		.ag-floating-top-viewport {
			border: none;
		}

		.ag-floating-top {
			border-color: ${colors.grey3};
		}

		.ag-row-pinned {
			border: none;

			&.ag-row-last {
				border: none;
			}

			.ag-cell {
				font-weight: bold;
			}
		}

		.ag-header-row-column {
			border-bottom: 1px solid ${colors.grey3};
		}
	}
`;

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
`;

export const ShowMoreWrapper = styled.div`
	display: flex;
	align-items: center;
	width: 100%;
	flex-direction: column;
`;

export const MenuWrapper = styled.div`
	position: absolute;
	top: ${props => props.top - 6 || 0}px;
	left: -24px;
	width: 32px;
	height: 32px;
`;
